import script from "./ModalCrearComunidad.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalCrearComunidad.vue?vue&type=script&setup=true&lang=js"

import "./ModalCrearComunidad.vue?vue&type=style&index=0&id=ce2d60ea&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce2d60ea"]])

export default __exports__